export enum InvoiceStatus {
    New,
    Edited,
    SentForBooking,
    Declined
}